import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaEventosOrdinariosTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            IDFluxoEvento: 0,
            RendaFixaCaracteristicasID: 1,
            Indexador: "N/A",
            LiquidezDiaria: 0,
            ValorNominal: 0,
            DataEvento: dayjs().format(DATE_FORMAT),
            DataEventoEfetiva: dayjs().format(DATE_FORMAT),
            DataAniversarioJuros: dayjs().format(DATE_FORMAT),
            DataLiquidacao: dayjs().format(DATE_FORMAT),
            DataRentabilidadeInicio: dayjs().format(DATE_FORMAT),
            DataRentabilidadeFim: dayjs().format(DATE_FORMAT),
            IndexadorCorrecaoPercentual: "N/A",
            Defasagem: 0,
            CalculoDiasIndexador: "N/A",
            FormulaIndexador: null,
            PeriodicidadeAtualizacaoMonetaria: null,
            MesAniversarioAnualSemestral: null,
            ProjecaoInflacao: null,
            InflacaoNegativa: null,
            RecalculoProjecao: null,
            AplicacaoAmortizacao: "N/A",
            AmortizacaoOrdinariaPercentual: 0,
            TaxaJuros: 0,
            CalculoDias: "N/A",
            JurosCapitalizacao: "N/A",
            JurosIncorporacaoProgramadaPercentual: 0,
            CalculoFatorJuros: "N/A",
            CasasFatorJuros: null,
            CalculoJuros: "N/A",
            CasasJuros: null,
            CalculoFatorCorrecao: "N/A",
            CasasFatorCorrecao: null,
            CalculoCorrecao: "N/A",
            CasasCorrecao: null,
            CalculoFatorJurosCDI: "N/A", 
            CasasFatorJurosCDI: null,
            CalculoVNA: "N/A",
            CasasVNA: null,
            CalculoFatorDesconto: "N/A",
            CasasFatorDesconto: null,
            CalculoFatorExpectativa: "N/A",
            CasasFatorExpectativa: null,
            CalculoPU: "N/A",
            CasasPU: null
        }

        props.loading(true)
        return datalakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID, IDFluxoEvento, RendaFixaCaracteristicasID, Indexador, LiquidezDiaria, ValorNominal,
            DataEvento, DataEventoEfetiva, DataAniversarioJuros, DataLiquidacao, DataRentabilidadeInicio, DataRentabilidadeFim,
            IndexadorCorrecaoPercentual, Defasagem, CalculoDiasIndexador, FormulaIndexador, PeriodicidadeAtualizacaoMonetaria,
            MesAniversarioAnualSemestral, ProjecaoInflacao, InflacaoNegativa, RecalculoProjecao, AplicacaoAmortizacao,
            AmortizacaoOrdinariaPercentual, TaxaJuros, CalculoDias, JurosCapitalizacao, JurosIncorporacaoProgramadaPercentual,
            CalculoFatorJuros, CasasFatorJuros, CalculoJuros, CasasJuros, CalculoFatorCorrecao, CasasFatorCorrecao, CalculoCorrecao,
            CasasCorrecao, CalculoFatorJurosCDI, CasasFatorJurosCDI, CalculoVNA, CasasVNA, CalculoFatorDesconto, CasasFatorDesconto, CalculoFatorExpectativa,
            CasasFatorExpectativa, CalculoPU, CasasPU
        } = newRow

        const body = {
            "IDFluxoEvento": IDFluxoEvento,
            "RendaFixaCaracteristicasID": RendaFixaCaracteristicasID,
            "Indexador": Indexador,
            "LiquidezDiaria": LiquidezDiaria,
            "ValorNominal": ValorNominal,
            "DataEvento": DataEvento,
            "DataEventoEfetiva": DataEventoEfetiva,
            "DataAniversarioJuros": DataAniversarioJuros,
            "DataLiquidacao": DataLiquidacao,
            "DataRentabilidadeInicio": DataRentabilidadeInicio,
            "DataRentabilidadeFim": DataRentabilidadeFim,
            "IndexadorCorrecaoPercentual": IndexadorCorrecaoPercentual,
            "Defasagem": Defasagem,
            "CalculoDiasIndexador": CalculoDiasIndexador,
            "FormulaIndexador": FormulaIndexador,
            "PeriodicidadeAtualizacaoMonetaria": PeriodicidadeAtualizacaoMonetaria,
            "MesAniversarioAnualSemestral": MesAniversarioAnualSemestral,
            "ProjecaoInflacao": ProjecaoInflacao,
            "InflacaoNegativa": InflacaoNegativa,
            "RecalculoProjecao": RecalculoProjecao,
            "AplicacaoAmortizacao": AplicacaoAmortizacao,
            "AmortizacaoOrdinariaPercentual": AmortizacaoOrdinariaPercentual,
            "TaxaJuros": TaxaJuros,
            "CalculoDias": CalculoDias,
            "JurosCapitalizacao": JurosCapitalizacao,
            "JurosIncorporacaoProgramadaPercentual": JurosIncorporacaoProgramadaPercentual,
            "CalculoFatorJuros": CalculoFatorJuros,
            "CasasFatorJuros": CasasFatorJuros,
            "CalculoJuros": CalculoJuros,
            "CasasJuros": CasasJuros,
            "CalculoFatorCorrecao": CalculoFatorCorrecao,
            "CasasFatorCorrecao": CasasFatorCorrecao,
            "CalculoCorrecao": CalculoCorrecao,
            "CasasCorrecao": CasasCorrecao,
            "CalculoFatorJurosCDI": CalculoFatorJurosCDI,
            "CasasFatorJurosCDI": CasasFatorJurosCDI,
            "CalculoVNA": CalculoVNA,
            "CasasVNA": CasasVNA,
            "CalculoFatorDesconto": CalculoFatorDesconto,
            "CasasFatorDesconto": CasasFatorDesconto,
            "CalculoFatorExpectativa": CalculoFatorExpectativa,
            "CasasFatorExpectativa": CasasFatorExpectativa,
            "CalculoPU": CalculoPU,
            "CasasPU": CasasPU

        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return datalakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }


    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'IDFluxoEvento',
            headerName: 'IDFluxoEvento',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'RendaFixaCaracteristicasID',
            headerName: 'RendaFixaCaracteristicasID',
            flex: 1,
            minWidth: 200,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Indexador',
            headerName: 'Indexador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'LiquidezDiaria',
            headerName: 'LiquidezDiaria',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ValorNominal',
            headerName: 'ValorNominal',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataEvento',
            headerName: 'DataEvento',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) return ''
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataEventoEfetiva',
            headerName: 'DataEventoEfetiva',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) return ''
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataAniversarioJuros',
            headerName: 'DataAniversarioJuros',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) return ''
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataLiquidacao',
            headerName: 'DataLiquidacao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) return ''
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataRentabilidadeInicio',
            headerName: 'DataRentabilidadeInicio',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) return ''
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'DataRentabilidadeFim',
            headerName: 'DataRentabilidadeFim',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) return ''
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'IndexadorCorrecaoPercentual',
            headerName: 'IndexadorCorrecaoPercentual',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Defasagem',
            headerName: 'Defasagem',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoDiasIndexador',
            headerName: 'CalculoDiasIndexador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FormulaIndexador',
            headerName: 'FormulaIndexador',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PeriodicidadeAtualizacaoMonetaria',
            headerName: 'PeriodicidadeAtualizacaoMonetaria',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'MesAniversarioAnualSemestral',
            headerName: 'MesAniversarioAnualSemestral',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ProjecaoInflacao',
            headerName: 'ProjecaoInflacao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'InflacaoNegativa',
            headerName: 'InflacaoNegativa',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'RecalculoProjecao',
            headerName: 'RecalculoProjecao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AplicacaoAmortizacao',
            headerName: 'AplicacaoAmortizacao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AmortizacaoOrdinariaPercentual',
            headerName: 'AmortizacaoOrdinariaPercentual',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TaxaJuros',
            headerName: 'TaxaJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoDias',
            headerName: 'CalculoDias',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'JurosCapitalizacao',
            headerName: 'JurosCapitalizacao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'JurosIncorporacaoProgramadaPercentual',
            headerName: 'JurosIncorporacaoProgramadaPercentual',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorJuros',
            headerName: 'CalculoFatorJuros',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorJuros',
            headerName: 'CasasFatorJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoJuros',
            headerName: 'CalculoJuros',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasJuros',
            headerName: 'CasasJuros',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorCorrecao',
            headerName: 'CalculoFatorCorrecao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorCorrecao',
            headerName: 'CasasFatorCorrecao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoCorrecao',
            headerName: 'CalculoCorrecao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasCorrecao',
            headerName: 'CasasCorrecao',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorJurosCDI',
            headerName: 'CalculoFatorJurosCDI',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorJurosCDI',
            headerName: 'CasasFatorJurosCDI',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoVNA',
            headerName: 'CalculoVNA',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasVNA',
            headerName: 'CasasVNA',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorDesconto',
            headerName: 'CalculoFatorDesconto',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorDesconto',
            headerName: 'CasasFatorDesconto',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoFatorExpectativa',
            headerName: 'CalculoFatorExpectativa',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasFatorExpectativa',
            headerName: 'CasasFatorExpectativa',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CalculoPU',
            headerName: 'CalculoPU',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CasasPU',
            headerName: 'CasasPU',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true} />
        </div>
    )
}

ParameterEmissaoRendaFixaEventosOrdinariosTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaEventosOrdinariosTable